<div class="inline-form-wrapper">
  <div class="inline-form-scroll">
    <form (submit)="$event.preventDefault(); handleSubmit($event)">
      <dx-form id="form" #personForm [(formData)]="formData">
        <dxi-item itemType="group" caption="Persönliche Daten" [colCount]="2">
          <dxi-item dataField="title">
            <dxo-label i18n-text="@@title" text="Title"></dxo-label>
            <div *dxTemplate="'titleTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.title"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="salutation" isRequired="true">
            <dxo-label i18n-text="@@salutation" text="Salutation"></dxo-label>
            <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
            <div *dxTemplate="'salutationTemplate'">
              <dx-select-box class="gpd-input" [(value)]="formData.salutation" [dataSource]="salutations" valueExpr="name" displayExpr="name">
              </dx-select-box>
            </div>
          </dxi-item>
          <dxi-item isRequired="true">
            <dxo-label i18n-text="@@firstname" text="Firstname"></dxo-label>
            <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
            <div *dxTemplate="'firstnameTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.firstname"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item isRequired="true">
            <dxo-label i18n-text="@@lastname" text="Lastname"></dxo-label>
            <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
            <div *dxTemplate="'lastnameTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.lastname"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item>
            <dxo-label i18n-text="@@birthdate" text="Birthdate"></dxo-label>
            <dx-date-box class="gpd-input" [(value)]="formData.birthDate" displayFormat="dd.MM.yyyy" dateSerializationFormat="yyyy-MM-dd"></dx-date-box>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" i18n-caption="@@address" caption="Address" [colCount]="2">
          <dxi-item dataField="address">
            <dxo-label i18n-text="@@address" text="Address"></dxo-label>
            <div *dxTemplate="'addressTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.address"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="zipcode">
            <dxo-label i18n-text="@@zipcode" text="Zipcode"></dxo-label>
            <div *dxTemplate="'zipcodeTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.zipcode"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="city">
            <dxo-label i18n-text="@@city" text="City"></dxo-label>
            <div *dxTemplate="'cityTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.city"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item [colSpan]="1" template="statesTemplate">
            <dxo-label i18n-text="@@country" text="Country"></dxo-label>
            <div *dxTemplate="let data of 'statesTemplate'">
              <dx-select-box
                class="gpd-input"
                [readOnly]="false"
                [(value)]="formData.countryId"
                [dataSource]="countriesByLanguageList"
                (onSelectionChanged)="handleCountryChange(formData.countryId)"
                displayExpr="countryName"
                valueExpr="countryId"
                acceptCustomValue="false">
              </dx-select-box>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" i18n-caption="@@contactCaps" caption="Contact" [colCount]="2">
          <dxi-item isRequired="true">
            <dxo-label i18n-text="@@email" text="Email"></dxo-label>
            <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
            <dxi-validation-rule type="email"></dxi-validation-rule>
            <div *dxTemplate="'emailTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.email"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="phoneMobile">
            <dxo-label i18n-text="@@phoneMobile" text="Phone (Mobile)"></dxo-label>
            <div *dxTemplate="'phoneMobileTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.phoneMobile"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="phonePrivate">
            <dxo-label i18n-text="@@phonePrivate" text="Phone (Private)"></dxo-label>
            <div *dxTemplate="'phonePrivateTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.phonePrivate"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="phoneCompany">
            <dxo-label i18n-text="@@phoneCompany" text="Phone (Company)"></dxo-label>
            <div *dxTemplate="'phoneCompanyTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.phoneCompany"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="fax">
            <dxo-label i18n-text="@@fax" text="Fax"></dxo-label>
            <div *dxTemplate="'faxTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.fax"></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>

      </dx-form>
    </form>

    <!-- Extension point for a caller-supplied Role picker — project-new-contact-modal and
         contacts-popup each project their own <gpd-role-select> here so it lands between
         Contact and Tags, matching the target design order. Not part of this component
         itself: the two callers need different validation behavior (one required and
         blocking Save, one optional/best-effort), so each owns its own role state instead
         of this component exposing a one-size-fits-all @Input for it. -->
    <ng-content></ng-content>

    <!-- Outside the dx-form on purpose: dx-form's group-caption divider is the top border of
         its .dx-form-group-content, sized to that content's own measured width — which
         DevExtreme gets right for its own widgets in a dxi-item but not reliably otherwise.
         Plain full-width div keeps Tags the same width as any projected Role block above it. -->
    <div class="inline-form-tags">
      <label class="inline-form-tags__label" i18n="@@tags">Tags</label>
      <div class="inline-form-tags__divider"></div>
      <dx-tag-box
        class="gpd-input"
        [items]="contactTags"
        displayExpr="title"
        valueExpr="id"
        [showSelectionControls]="true"
        applyValueMode="useButtons"
        [(value)]="formData.tags"
        i18n-placeholder="@@select"
        placeholder="Select"
        [inputAttr]="{ 'aria-label': 'Tags' }">
      </dx-tag-box>
    </div>
  </div>

</div>

<dx-toast [visible]="toastVisible" [type]="type" message="{{ message }}" position="bottom center" width="fit-content"></dx-toast>
